import { useEffect, useRef, useState } from "react"
import { useLanguage } from "@shared/hooks/useTranslation"
import { DEFAULT_DISCOUNT } from "./Panel/discountConfig"

type AddonsBuckets = {
  core: number
  support: number
  marketing: number
  marketingExpert: number
  enterpriseMarketing: number
  enterpriseSupport: number
}

type AddonPicked = {
  bucket: keyof AddonsBuckets
  price: number
  index?: number
}

export const usePriceState = (initialTeam: "marketing" | "support" = "marketing") => {
  const [range, setRange] = useState(0)
  const [discount, setDiscount] = useState<number>(DEFAULT_DISCOUNT)

  const [features, setFeatures] = useState({ show: false, differences: false })

  const emptyBuckets: AddonsBuckets = {
    core: 0,
    support: 0,
    marketing: 0,
    marketingExpert: 0,
    enterpriseMarketing: 0,
    enterpriseSupport: 0,
  }

  const [addons, setAddons] = useState<AddonsBuckets>(emptyBuckets)
  const [addonsCount, setAddonsCount] = useState<AddonsBuckets>(emptyBuckets)

  const [addonsList, setAddonsList] = useState<string[]>([])
  const [addonsSelect, setAddonsSelect] = useState<Record<string, number>>({})

  const [addonsPicked, setAddonsPicked] = useState<Record<string, AddonPicked>>({})

  const [team, setTeam] = useState<"marketing" | "support">(initialTeam)

  const allFeatures = useRef<HTMLDivElement | null>(null)

  const { selectedLang } = useLanguage()
  const fallbackLang = process.env.GATSBY_LANG || "ru"

  const [text, setText] = useState<any>(() => require(`./locales/${fallbackLang}.json`))

  useEffect(() => {
    if (selectedLang && selectedLang !== fallbackLang) {
      import(`./locales/${selectedLang}.json`).then((m) => setText((m as any).default ?? m)).catch(() => {})
    }
  }, [selectedLang, fallbackLang])

  useEffect(() => {
    setAddons(emptyBuckets)
    setAddonsCount(emptyBuckets)
    setAddonsSelect({})
    setAddonsList([])
    setAddonsPicked({})
  }, [team])

  return {
    range,
    setRange,
    discount,
    setDiscount,
    features,
    setFeatures,
    addons,
    setAddons,
    addonsCount,
    setAddonsCount,
    addonsList,
    setAddonsList,
    addonsSelect,
    setAddonsSelect,
    addonsPicked,
    setAddonsPicked,
    team,
    setTeam,
    text,
    allFeatures,
  }
}
